var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import constate from 'constate';
import Cookies from 'js-cookie';
import { useCallback, useEffect, useState } from 'react';
import { MakhazinAuthApi } from '../Api/MakhazinAuthApi';
import add from 'date-fns/add';
import { useNavigate } from 'react-router-dom';
const cookieOptions = {
    expires: add(new Date(), { days: 30 }),
};
function getInitialAccessToken() {
    return Cookies.get('accessToken');
}
function getInitialRefreshToken() {
    return Cookies.get('refreshToken');
}
function getInitialImpersonation() {
    return localStorage['impersonatedAs'];
}
function fetchUser(accessToken, refreshToken, impersonatedAs, handleRefreshedToken, logoutUser) {
    return __awaiter(this, void 0, void 0, function* () {
        if (accessToken && refreshToken) {
            const api = new MakhazinAuthApi(accessToken, refreshToken, handleRefreshedToken, logoutUser, impersonatedAs);
            const usr = yield api.getUser();
            return usr;
        }
        else {
            return null;
        }
    });
}
const useUserContext_ = () => {
    const [accessToken, setAccessToken] = useState(getInitialAccessToken);
    const [refreshToken, setRefreshToken] = useState(getInitialRefreshToken);
    const [impersonatedAs, setImpersonatedAs] = useState(getInitialImpersonation);
    const [user, setUser] = useState(undefined);
    const navigate = useNavigate();
    const loginUser = (user, accessToken, refreshToken) => {
        setUser(user);
        setAccessToken(accessToken);
        setRefreshToken(refreshToken);
        Cookies.set('accessToken', accessToken, cookieOptions);
        Cookies.set('refreshToken', refreshToken, cookieOptions);
        return '/mypages';
    };
    const handleRefreshedToken = (accessToken, refreshToken) => {
        setAccessToken(accessToken);
        setRefreshToken(refreshToken);
        Cookies.set('accessToken', accessToken, cookieOptions);
        Cookies.set('refreshToken', refreshToken, cookieOptions);
    };
    const impersonateUser = (impersonatedAs) => {
        setImpersonatedAs(impersonatedAs);
        localStorage.setItem('impersonatedAs', impersonatedAs);
    };
    const exitImpersonation = () => {
        setImpersonatedAs(undefined);
        localStorage.removeItem('impersonatedAs');
    };
    const logoutUser = () => {
        setUser(undefined);
        localStorage.clear();
        Cookies.remove('accessToken');
        Cookies.remove('refreshToken');
        navigate('/login');
    };
    const refreshUser = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (accessToken && refreshToken) {
            const user = yield fetchUser(accessToken, refreshToken, impersonatedAs, handleRefreshedToken, logoutUser);
            setUser(user);
        }
        else {
            setUser(null);
        }
    }), [accessToken, refreshToken, impersonatedAs]);
    useEffect(() => {
        refreshUser();
    }, [refreshUser]);
    return {
        user,
        accessToken,
        refreshToken,
        loginUser,
        logoutUser,
        impersonatedAs,
        impersonateUser,
        exitImpersonation,
        handleRefreshedToken,
        refreshUser,
        loggedIn: accessToken !== undefined,
    };
};
export const [Provider, useUserContext] = constate(useUserContext_);
